import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, canonicalUrl }) => {
    console.log(title, description, canonicalUrl);
    return (
        <>
            <Helmet defer={false}>
                <title>{title}</title>
                <meta name="description" content={description} />
                <link rel="canonical" href={canonicalUrl} />
            </Helmet>
        </>
    );
};

export default SEO;
